import client from '@/api/client'; // NOT 'clientRetryable' (エラーログ送信はシンプルに実施する)
import store from '@/store';
import getAuthHeader from '@/util/getAuthHeader';
import getRequestHeader from '@/util/getRequestHeader';
import moment from 'moment-timezone';

export type LogLevel = 'ERROR' | 'WARN' | 'INFO';

export interface ClientLogRequest {
  level: LogLevel;
  time?: string;
  kind: string;
  fields?: string[];
  message?: string;
}

export async function sendLog(request: ClientLogRequest): Promise<boolean> {
  try {
    const data: ClientLogRequest = Object.assign(request, { time: request.time || moment.utc().format() });
    if (store.getters['auth/accessToken']) {
      // ログ送信 accessTokenはヘッダを通して送られる
      await client.post('/client_logs', data, { headers: getAuthHeader() });
    } else {
      // 何らかの理由で認証していない場合 requestTokenはヘッダを通して送られる
      await client.post('/unauthorized/client_logs', data, { headers: getRequestHeader() });
    }
    // ログ送信成功
    return true;
  } catch (error) {
    // ログ送信失敗　エラーは握り潰す
    console.error(error); // eslint-disable-line no-console
    return false;
  }
}
